






















































































































import { computed, defineComponent, PropType, ref, useStore, onBeforeMount, onMounted } from '@nuxtjs/composition-api';
import { maxBy } from 'lodash-es';
import ProductWineColorLabel from '~/components/pages/Product/ProductWineColorLabel.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppOptimizedImage from '~/components/partials/App/AppOptimizedImage.vue';
import ProducingAreaFlag from '~/components/partials/ProducingArea/ProducingAreaFlag.vue';
import ProductLabel from '~/components/partials/Product/ProductLabel.vue';
import { useSilverEggApi } from '~/composables/silverEgg/useSilverEggApi';
import { BOTTLE_200 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { sendGaEvent as sendEvent, GaTopPartsType } from '~/utils/ga';
import { getSpecialPricePromotion, filterReviewRating, convertColorText } from '~/utils/modules/products';
import { CommonProducingArea } from '~/types/common';
import { ConvertedRecommendItem } from '~/types/common/silverEgg';
import { ProductVariantShow } from '~/types/modules/product';
import { TopItemDetail } from '~/types/modules/top';
import { PromotionsName } from '~/enums';

export default defineComponent({
  components: {
    AppOptimizedImage,
    AppLink,
    AppIcon,
    ProductWineColorLabel,
    ProducingAreaFlag,
    ProductLabel,
  },
  props: {
    item: {
      type: Object as PropType<TopItemDetail | ConvertedRecommendItem>,
      required: true,
    },
    withScore: {
      type: Boolean,
      default: false,
    },
    gaPartsType: {
      type: String as PropType<GaTopPartsType>,
      default: null,
    },
    gaEventLabel: {
      type: String,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    // キャッチコピーを吹き出しにするかどうか
    useSpeechBubble: {
      type: Boolean,
      default: false,
    },
    // テキスト行数を制限するかどうか（商品名と生産地が最大2行になる）
    isClamped: {
      type: Boolean,
      default: false,
    },
    showSaleLabel: {
      type: Boolean,
      default: false,
    },
    // ↓シルバーエッグ用↓
    foodRqid: {
      type: String,
      default: '',
    },
    rqid: {
      type: String,
      default: '',
    },
    spec: {
      type: String,
      default: '',
    },
    // ↑シルバーエッグ用↑
  },
  setup(props) {
    const store = useStore();
    const { clickNotify } = useSilverEggApi();
    const productVariants = ref<ProductVariantShow[]>([]);
    const productVariant = computed(() =>
      productVariants.value.find((product) => product.code === props.item.variantCode)
    );

    const styleHeight = computed(() => {
      if (props.height) {
        return { height: props.height + 'px' };
      }
    });

    /**
     * 最も高得点の評価紙の略称とポイントを返す
     * 子商品が登録されている場合、子商品情報から評価紙ポイントを取得する
     */
    const highestReviewMediumInfo = computed(() => {
      if (!productVariant.value?.review_medium_info) {
        return;
      }
      const { review_medium_info } = productVariant.value;
      /**
       * スコア表示用変数
       */
      const scoreListForDisplay = [
        { mark: 'WA', score: review_medium_info.wa_point ?? '' },
        { mark: 'WS', score: review_medium_info.ws_point ?? '' },
        { mark: 'WE', score: review_medium_info.we_point ?? '' },
        { mark: 'JS', score: review_medium_info.js_point ?? '' },
        { mark: 'D', score: review_medium_info.d_point ?? '' },
        { mark: 'V', score: review_medium_info.v_point ?? '' },
      ];
      /**
       * スコアソート用変数
       */
      const scoreListForSorting = [
        { mark: 'WA', score: review_medium_info.wa_sort ?? 0 },
        { mark: 'WS', score: review_medium_info.ws_sort ?? 0 },
        { mark: 'WE', score: review_medium_info.we_sort ?? 0 },
        { mark: 'JS', score: review_medium_info.js_sort ?? 0 },
        { mark: 'D', score: review_medium_info.d_sort ?? 0 },
        { mark: 'V', score: review_medium_info.v_sort ?? 0 },
      ];
      const maxValue = maxBy(scoreListForSorting, 'score');
      return scoreListForDisplay.find((item) => item.mark === maxValue?.mark);
    });
    const reviewMediumInfo = computed(() => {
      if (highestReviewMediumInfo.value?.score == null) {
        return;
      }
      return highestReviewMediumInfo.value;
    });

    const colorText = computed(() => convertColorText(props.item.product.color));

    const producingArea = computed((): CommonProducingArea => {
      const { producing_area } = props.item.product;

      // リンクなしの仕様なので、areas.idは不要です
      return {
        code_id: producing_area.area_id_1 || '',
        areas: [
          {
            name: producing_area.area_1,
          },
          {
            name: producing_area.area_2,
          },
          {
            name: producing_area.area_3,
          },
        ],
      };
    });
    const displayPrice = computed(() => {
      if (productVariant.value) {
        return productVariant.value?.price_settings?.price_including_tax.toLocaleString();
      }
      if (typeof props.item.product.display_price === 'number') {
        return props.item.product.display_price.toLocaleString();
      } else {
        return props.item.product.display_price?.slice(0, props.item.product.display_price.indexOf('円'));
      }
    });
    const sendGaEvent = () => {
      if (!props.gaPartsType) {
        return;
      }
      if (props.gaEventLabel) {
        sendEvent(props.gaPartsType, url('ITEM_DETAIL', { code: props.item.code }), props.gaEventLabel);
        return;
      }
      sendEvent(props.gaPartsType, url('ITEM_DETAIL', { code: props.item.code }), props.item.product.name);
    };
    const sendSilverEggRequest = async () => {
      if (!props.spec || (props.item.isSeFood ? !props.foodRqid : !props.rqid)) return;

      await clickNotify({
        itemId: props.item.code,
        spec: props.spec,
        rqid: props.item.isSeFood ? props.foodRqid : props.rqid,
      });
    };
    const onClick = async () => {
      sendGaEvent();
      await sendSilverEggRequest();
    };
    /**
     * dev, stg環境でのみ画像パスの末尾に /original がつくデータが存在するため、プロファイルを差し替える
     */
    const imageUrl = computed(() => {
      if (!props.item.image) return;

      return props.item.image.split('/').slice(-1)[0] === 'original'
        ? props.item.image.replace('/original', BOTTLE_200)
        : props.item.image + BOTTLE_200;
    });
    const productVariantSalePrice = computed(() => getSpecialPricePromotion(productVariant.value?.price_settings));

    /**
     * 特定の子商品が取得されている場合とそうでない場合で、セール表示のための条件を振り分ける
     */
    const isSalePrice = computed(() => {
      if (productVariant.value) {
        return productVariantSalePrice.value?.price_including_tax;
      }
      return props.item.product.is_discount === 1 || props.item.product.special_price;
    });
    /**
     * 特定の子商品が取得されている場合とそうでない場合で、送料無料表示のための条件を振り分ける
     */
    const isFreeShipping = computed(() => {
      if (productVariant.value) {
        return productVariant.value.price_settings.is_free_shipping;
      }
      return props.item.product.is_free_shipping === 1;
    });
    /**
     * ハイエンドセレクションは子商品コードが登録されてる
     * ECの商品詳細APIから評価誌情報を取得
     */
    onBeforeMount(async () => {
      if (props.item.variantCode) {
        const res = await store.dispatch('product/detail/fetchECProductDetail', {
          path: {
            code: props.item.code,
          },
        });
        productVariants.value = res.product_variants;
      }
    });

    const catchCopyHeight = ref('auto');

    onMounted(() => {
      // 吹き出しの最大の高さを取得し、高さを揃える
      const catchCopies = document.querySelectorAll('.speech-bubble');
      catchCopyHeight.value = `${maxBy([...catchCopies], 'clientHeight')?.clientHeight}px`;
    });

    const saleLabel = computed(() => {
      return props.item.product.sale_label;
    });

    return {
      url,
      reviewMediumInfo,
      producingArea,
      imageUrl,
      productVariant,
      productVariantSalePrice,
      filterReviewRating,
      styleHeight,
      displayPrice,
      PromotionsName,
      onClick,
      catchCopyHeight,
      saleLabel,
      colorText,
      isSalePrice,
      isFreeShipping,
    };
  },
});
